export const formatToTwoDecimal = (value: number): string => {
  return typeof value === 'number' ? value.toLocaleString('en-AU', { minimumFractionDigits: 2 }) : value;
};

export const formatToWholeNumber = (value: number): number => {
  return typeof value === 'number' ? Math.round(value) : value;
};

export const capitalizeFirstLetter = ([first, ...rest]: string): string => {
  return [first.toUpperCase(), ...rest].join('');
};

export const convertToPascalCase = (value: string): string => {
  return value.replace(/\w+/g, (w) => {
    return w[0].toUpperCase() + w.slice(1).toLowerCase();
  });
};
